import React from 'react';

export function BillingLocations({ locations, dayStart }) {
  if (!locations.length) return <span>Information non disponible</span>;
  return locations.map((location, index) => <span key={index} className="block">
    <strong className="font-semibold text-slate-700">{location.name || (dayStart ? 'Départ de journée' : 'Nom non disponible')}</strong>
    <span> · {location.address || 'Adresse non disponible'}</span>
  </span>);
}

export default function BillingServiceRoute({ context }) {
  return <dl className="billing-service-route grid grid-cols-[auto_minmax(0,1fr)] gap-x-2 gap-y-1 text-xs text-slate-500" aria-label="Lieux du trajet enregistré">
    <dt className="font-medium text-slate-600">Départ</dt>
    <dd className="min-w-0 break-words">{!context.origin.length && context.origin_kind === 'visit' ? <span>Livraison précédente · autre client</span>
      : <BillingLocations locations={context.origin} dayStart={context.origin_kind === 'day_start'} />}</dd>
    <dt className="font-medium text-slate-600">Arrivée</dt>
    <dd className="min-w-0 break-words"><BillingLocations locations={context.destination} /></dd>
  </dl>;
}
